export interface GetFilteredValidationRulesRequest extends PagingSortingBaseRequest {
  filterType: FilterType;
  companyIds?: number[];
  assetTypeId?: number;
  isActive?: boolean,
  sortBy: SortingValidation;
}

export enum SortingValidation {
  createdOn = 'createdOn',
  updatedOn = 'updatedOn'
}

export enum FilterType {
  all,
  company,
  assetType
}

export interface PagingSortingBaseRequest {
  quickSearch: string;
  asc: boolean;
  skip: number;
  take: number;
}
